module.exports = __webpack_public_path__ + "img/kingmakerAct.7aa2a24d.jpg";